import { render, staticRenderFns } from "./TravelsPurposesDistancesBar.vue?vue&type=template&id=4669912c"
import script from "./TravelsPurposesDistancesBar.vue?vue&type=script&lang=js"
export * from "./TravelsPurposesDistancesBar.vue?vue&type=script&lang=js"
import style0 from "./TravelsPurposesDistancesBar.vue?vue&type=style&index=0&id=4669912c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports